export default __webpack_public_path__ + "static/11.09-d1e4ce1c800d8aea531a401781f2d631.png";